var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_4070)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.7574C16.5228 21.7574 21 17.2803 21 11.7574C21 6.2346 16.5228 1.75745 11 1.75745C5.47715 1.75745 1 6.2346 1 11.7574C1 17.2803 5.47715 21.7574 11 21.7574Z",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_4070",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.7574C16.5228 21.7574 21 17.2803 21 11.7574C21 6.2346 16.5228 1.75745 11 1.75745C5.47715 1.75745 1 6.2346 1 11.7574C1 17.2803 5.47715 21.7574 11 21.7574Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_4070)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.757446H7V9.75745H0V13.7574H7V22.7574H11V13.7574H22V9.75745H11V0.757446Z",
    fill: "#6FB1D6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_4070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1 1.75745)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi);
export default __webpack_public_path__ + "static/media/fi.bead2f8efe2c3cc5ef3d491df88ee6db.svg";
export { ForwardRef as ReactComponent };